import React, {PropTypes as T} from 'react';
import {ModalHeader} from '../../common/modal';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';

export default class IconErrorHeader extends React.Component {
  static propTypes = {
    title: T.string
  };

  render () {
    return (
      <ModalHeader isError>
        <div className="modal__header__icon__wrapper">
          <ModalCautionIcon className="modal__header__icon" />
        </div>
        <div className="modal__header_title">{this.props.title}</div>
      </ModalHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/modal/icon_error_header.js